import { isDefined } from "@clipboard-health/util-ts";
import { useFormContext } from "react-hook-form";

import { SingleSelectQuestion } from "../components/SingleSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";

const options = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

interface HasCarStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function HasCarStep(props: HasCarStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("hasCar");
  const stringValue = isDefined(value) ? String(value) : undefined;

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="Do you have a car?"
      continueDisabled={!isDefined(value)}
      onBack={onBack}
      onContinue={onContinue}
    >
      <SingleSelectQuestion
        options={options}
        value={stringValue}
        onChange={(v) => {
          setValue("hasCar", v === "true");
        }}
      />
    </SurveyStepLayout>
  );
}
